import { ManufacturerType } from 'src/app/entities/filters/other-filters/enums/other-filters.enums';
import { BackendViewNames } from 'src/app/entities/products/enums/product-views.enum';
import { Country } from '@app-shared/models/country.model';

import { IATC } from '../../filters/atc/state/atc.model';
import { IManufacturer } from '../../filters/manufacturers/state/manufacturer.model';
import { IMolecule } from '../../filters/molecules/state/molecule.model';

interface IFavoriteFilterPermissions {
  /** If a filter can be deleted */
  deletable?: boolean;
  /** If the name of the filter can be changed */
  name_updatable?: boolean;
  /** If the notification settings for the favorite filter can be changed */
  notifications_updatable?: boolean;
  /** If the favorite filter can have it's values changed such as: query, atcs, manufacturers or any other filter */
  filters_updatable?: boolean;
}

export interface IFavoriteFilter extends IFavoriteFilterPermissions {
  id?: number | null;
  user_id: number | null;
  name: string | null;
  query: string | null;
  filters: {
    atc: IATC[];
    countries: Country[];
    manufacturer: IManufacturer[];
    molecule: IMolecule[];
    otc: boolean | null;
    btm: boolean | null;
    tender: boolean | null;
    manufacturer_type: ManufacturerType | null;
    expected_shortage_date: boolean | null;
  };
  email_notifications: boolean | null;
  application_notifications: boolean | null;
  shortage_notifications: boolean | null;
  back_in_stock_notifications: boolean | null;
  default: boolean;
  target_meta: IFavoriteFilterMeta | null;
}

export interface IFavoriteFilterMeta {
  target: number | null;
  parent: number;
  tab: BackendViewNames;
}

export function createFavoriteFilter(
  params: Partial<IFavoriteFilter>,
): IFavoriteFilter {
  return {
    id: null,
    user_id: null,
    name: null,
    query: null,
    filters: {
      atc: [],
      countries: [],
      manufacturer: [],
      molecule: [],
      otc: false,
      btm: false,
      tender: false,
      manufacturer_type: null,
      expected_shortage_date: null,
    },
    email_notifications: null,
    application_notifications: null,
    shortage_notifications: null,
    back_in_stock_notifications: null,
    default: false,
    target_meta: null,

    ...params,
  } satisfies IFavoriteFilter;
}
